import styled from 'styled-components';

const SparkLineWrapper = styled.div`
    padding-top: 15px;
    width: 95%;
`;

const CategoriesWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 95%;
    padding-top: 2px;
    font-size: 8px;
    color: ${props => props.theme.callouts.colors.categories}
`;

const SparklineTitleWrapper = styled.div`
    display: flex;
    justify-content: center;
    font-size: 10px;
    width: 95%;
    margin-top: -10px;
    color: '#8A8A8A'
`;

const WindowsWrapper = styled(CategoriesWrapper)`
    font-size: 10px;
`;

const WindowSpan = styled.span`
    width: 50%;
    text-align: center;
`;

export {
    SparkLineWrapper,
    SparkLineWrapper as BoxPlotWrapper,
    CategoriesWrapper,
    SparklineTitleWrapper,
    WindowsWrapper,
    WindowSpan,
};



// WEBPACK FOOTER //
// ./src/components/atoms/callout/SparkLine.js